import React from "react";

const HRLayout = ({ children }: any) => {
  return (
    <div className="flex min-h-screen">

      {/* SIDEBAR */}
      <div className="w-64 bg-gray-100 p-4 space-y-4">
        <h2 className="font-bold text-lg">InfoTech</h2>

        <a href="#hr-dashboard" className="block hover:text-green-500">
          Dashboard
        </a>

        <a href="#employees" className="block hover:text-green-500">
          Candidates
        </a>

        <a href="#jobs" className="block hover:text-green-500">
          Job Postings
        </a>

        <a href="#leave" className="block hover:text-green-500">
          Leave Requests
        </a>

        <a href="#payroll" className="block hover:text-green-500">
          Payroll
        </a>
      </div>

      {/* CONTENT */}
      <div className="flex-1 p-6 pt-24 bg-gray-50">
        {children}
      </div>

    </div>
  );
};

export default HRLayout;